type VoidHandler = (...args: any[]) => void;

/**
 * Returns a function which when called, invokes the provided handler function a maximum of once per
 * the provided delay, with the latest available arguments.
 *
 * @param handler A function to be throttled.
 * @param config A reference to an object containing the minimum duration between throttled function
 *  calls in milliseconds (`.delay`).
 */

const throttle = (handler: VoidHandler, config: {delay: number}): VoidHandler => {
    let timerId: number | null = null;
    let last: number = -Infinity;

    return function (this: any, ...args: any[]): void {
        const now = Date.now();

        const later = () => {
            timerId = null;

            handler.call(this, ...args);

            last = now;
        };

        if (timerId === null && now >= last + config.delay) {
            later();
        } else {
            const difference = now - last;

            clearTimeout(timerId!);

            timerId = setTimeout(later, config.delay - difference) as any;
        }
    };
};

export default throttle;
